import { Text } from 'components'
import { FormikCheckbox, FormikTextField } from 'formik-office-ui-fabric-react'
import { Box } from 'grid'
import { Worker, WorkerInsertType, WorkerSetType } from 'model'
import { Label } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
import { FieldStack, FieldStackItem, FormStack, Stack } from '../FormStack'

export type WorkerFormValues = (WorkerInsertType | WorkerSetType) & {
  id: string
}
interface WorkerFormProps {
  isCreateNewForm: boolean
}
export const workerDefaultValues: Partial<Worker> = {
  qBasic: false,
  qMuLow: false,
  qNordschleife: false,
  qOffroad: false,
  qSupersport: false,
  qTurbo: false,
}

export function getWorkerFormSchema() {
  return Yup.object().shape({
    firstName: Yup.string().required().trim(),
    lastName: Yup.string().required().trim(),
    company: Yup.string().required().trim(),
    department: Yup.string().required().trim(),
    _id: Yup.string().required(),
  })
}

export const WorkerForm: React.FunctionComponent<WorkerFormProps> = ({
  isCreateNewForm,
}) => {
  const { t } = useTranslation()
  return (
    <FormStack>
      <FieldStack horizontal={true}>
        <FieldStackItem
          name="firstName"
          label={t('field.firstName.label')}
          required={true}
          component={FormikTextField}
        />
        <FieldStackItem
          name="lastName"
          label={t('field.lastName.label')}
          required={true}
          component={FormikTextField}
        />
      </FieldStack>
      <FieldStack horizontal={true}>
        <FieldStackItem
          name="company"
          label={t('field.company.label')}
          required={true}
          component={FormikTextField}
        />
        <FieldStackItem
          name="department"
          label={t('field.department.label')}
          required={true}
          component={FormikTextField}
        />
      </FieldStack>

      <FieldStackItem
        name="_id"
        label={t('field.pid.label')}
        required={isCreateNewForm}
        disabled={!isCreateNewForm}
        component={FormikTextField}
      />

      <FieldStackItem
        name="annotation"
        label={t('field.annotation.label')}
        multiline={true}
        component={FormikTextField}
      />
      <Stack.Item>
        <Text font="xLarge" mt={2} mb={1}>
          {t('forms:qualifications')}
        </Text>
      </Stack.Item>
      <FieldStack>
        <FieldStack horizontal={true} wrap={true}>
          {[
            'qBasic',
            'qTurbo',
            'qSupersport',
            'qNordschleife',
            'qMuLow',
            'qOffroad',
          ].map((fieldName) => (
            <FieldStackItem
              key={fieldName}
              stack={{ styles: { root: { width: 150 } } }}
              name={fieldName}
              label={t(`field.${fieldName}.label`)}
              component={FormikCheckbox}
            />
          ))}
        </FieldStack>
      </FieldStack>
      <FieldStack>
        <Box py={4}>
          <FieldStackItem
            stack={{ grow: 0 }}
            name="inactive"
            render={(fieldProps) => (
              <>
                <Label>{t('field.inactive.label')}</Label>
                <Box py={1}>
                  <FormikCheckbox {...fieldProps} />
                </Box>
              </>
            )}
          />
        </Box>
      </FieldStack>
    </FormStack>
  )
}
